import { OpuSearchRequirementsType } from '../utils/types';

export const initialState: OpuSearchRequirementsType = {
  showForm: false,
};
